import styled, { css } from 'styled-components';
import { palette, switchProp, theme } from 'styled-tools';

export const TipseenWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: fit-content;
`;

export const TipseenContent = styled.div`
  position: absolute;
  width: fit-content;
  padding: ${theme('spacing.md')};
  background-color: ${palette('primary')};
  margin-bottom: ${theme('spacing.sm')};
  border-radius: ${theme('borderRadius.sm')};
  grid-template-columns: repeat(2, 1fr);
  /* z-index: 200; */
  display: grid;
  gap: ${theme('spacing.sm')};
  opacity: ${({ show }) => (show ? 1 : 0)};
  ${switchProp('placement', {
    top: css`
      bottom: 100%;
      &:after {
        content: ' ';
        width: 0;
        height: 0;
        position: absolute;
        border-top: 10px solid;
        border-color: ${palette('primary')};
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        top: 100%;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        text-align: center;
      }
    `,
  })}
`;
export const TipseenTrigger = styled.div`
  z-index: 400;
  cursor: pointer;
`;
